import React, { Component } from 'react';
import './LoginComponent.css';
import { loginOtp, verifyLoginOtp, createLogin } from "../../actions/loginActions";
// import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Redirect } from 'react-router-dom';
import ReactModal from 'react-modal';

const customStylesDO = {
  overlay: {
    background: 'rgba(0, 0, 0, 0.55)',
    zIndex: 1000,
  },
  content: {
    inset: 'auto',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 'calc(100% - 32px)',
    maxWidth: '460px',
    background: '#ffffff',
    border: 'none',
    borderRadius: '12px',
    overflow: 'hidden',
    padding: 0,
    boxShadow: '0 20px 60px rgba(0,0,0,0.4)',
  },
};

class LoginComponent extends Component {
  constructor() {
    super();
    this.state = {
      username: '',
      password: '',
      redirect: false,
      errors: [],
      loginOtp: false,
      seconds: '0',
      inputOtp: '',
      otpType: '',
      isDisabled:false,
    }
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleValidation() {
    const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const mobileRegex = /^[6789]\d{9}$/;
    let errors = {};
    let validity = true;
    if (this.state.username === '') {
      errors["username"] = "Please enter login credentials";
      validity = false;
      this.setState({ otpType: '' });
    } else if (!emailRegex.test(this.state.username) && !mobileRegex.test(this.state.username)) {
      errors["username"] = "Invalid credentials";
      validity = false;
      this.setState({ otpType: '' });
    } else if (emailRegex.test(this.state.username)) {
      this.setState({ otpType: 'email' });
    } else if (mobileRegex.test(this.state.username)) {
      this.setState({ otpType: 'mobile' });
    }
    // if(this.state.password == ''){
    //   errors["password"] = "Please enter your password";
    //   validity = false
    // }
    this.setState({ errors: errors });
    return validity;
  }

  handleLoginTimer = ()=> {
    setTimeout(()=> {
       this.setState({isDisabled:false})
    },30000)
  }

  handleSubmit = async (e) => {
    e.preventDefault();
    let data = {
      'username': this.state.username,
    }
     if (this.handleValidation() !== false) {
        if(!this.state.isDisabled){
      this.setState({isDisabled:true})
      let resLoginOtp = await this.props.loginOtp(data);
      this.setState({isDisabled:false})
      if (resLoginOtp) {
        this.setState({ openOtp: true });
        if (this.state.seconds <= 0) {
          this.setState({ seconds: 60, inputOtp: '' });
          clearInterval(this.timer)
          this.startTimer();
        }
      }
  }
   
      // this.handleLoginTimer()
    }
  
  }

  handleChange(e) {
    this.setState({
      [e.target.name]: e.target.value
    });
  }

  state = {
    isPasswordShown: false
  }

  togglePasswordVisiblity = () => {
    const { isPasswordShown } = this.state;
    this.setState({ isPasswordShown: !isPasswordShown });
  }

  resend = async () => {
    let data = {
      'username': this.state.username
    }
    await this.props.loginOtp(data);
    this.setState({ openOtp: true, seconds: 60, inputOtp: '' });
    clearInterval(this.timer)
    this.startTimer();
  }

  startTimer() {
    this.timer = setInterval(() => {
      const { seconds } = this.state
      if (seconds > 0) {
        this.setState(({ seconds }) => ({
          seconds: seconds - 1
        }))
      }
      if (seconds === 0) {
        clearInterval(this.timer)
      }
    }, 1000)
    // this.setState({seconds:5})
  }

  verifyOtp = async () => {
    var regex = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/;
    if (regex.test(this.state.inputOtp)) {
      alert("Please remove special characters!")
    }
    else {
      let data = {
        'username': this.state.username,
        'otp': this.state.inputOtp
      }
      await this.props.createLogin(data);
      let loginRes = this.props.loginRes;
      if (loginRes.message === "Account Blocked for an hour!!") {
        this.setState({ openOtp: false });
      }
    }
  }

  render = () => {
    const { redirect, seconds } = this.state
    if (redirect) {
      return <Redirect to={{
        pathname: '/dashboard',
      }} />
    };
    return (
      <div className="container login-container">
        <div className="login-form">
          <div className="loginForm">
            <label className="login">Login</label>

            <form action="" onSubmit={this.handleSubmit}>
              <div>
                <input className="rectangle-user" id ='enterMailMobile' type="username" name="username" placeholder="Email Id/Mobile number" onChange={this.handleChange} />
                <i className="fa fa-user user-icon" ></i>
                <div className="error_add">
                  <span className ="errorShow">{this.state.errors["username"]}</span>
                </div>
              </div>
              {/* <div>
                <input className="rectangle-pass" name="password" type={isPasswordShown ? "text" : "password"} placeholder="Password" onChange={this.handleChange} maxLength={10} />
                < i className={`fa ${isPasswordShown ? "fa-eye" : "fa-eye-slash"} password-icon`} onClick={this.togglePasswordVisiblity} />
                </div>
              <div className="error_add">
                <span className="errorShow">{this.state.errors["password"]}</span>
              </div>
              <div>
                <label className="forget-pass" onClick={this.onForgotPass}><a href="/forgot-password">Forgot password?</a></label>
              </div>
              <div className="rem">
                <input className="checkbox" type="checkbox" value="rememberme" />	<label className="rememberme"> Remember me</label>
              </div> */}
              <div className="buttonLogin" onClick={this.handleSubmit}>
                <label className="loginText">{"Log in"}</label>
              </div>
            </form>
          </div>
        </div>
        <div className="login_img">
          <svg viewBox="0 0 600 700" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <defs>
              <radialGradient id="loginHeroGlow" cx="50%" cy="50%" r="50%">
                <stop offset="0%" stopColor="#fa9f22" stopOpacity="0.35" />
                <stop offset="55%" stopColor="#fa9f22" stopOpacity="0.06" />
                <stop offset="100%" stopColor="#fa9f22" stopOpacity="0" />
              </radialGradient>
              <linearGradient id="loginHeroOrb" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" stopColor="#ffb454" />
                <stop offset="100%" stopColor="#eb851f" />
              </linearGradient>
            </defs>

            {/* soft glow */}
            <circle className="hero-glow" cx="300" cy="320" r="320" fill="url(#loginHeroGlow)" />

            {/* concentric rings — gentle breathing pulse */}
            <g className="hero-rings">
              <circle cx="300" cy="320" r="220" fill="none" stroke="#fa9f22" strokeOpacity="0.18" strokeWidth="1.5" />
              <circle cx="300" cy="320" r="170" fill="none" stroke="#fa9f22" strokeOpacity="0.3" strokeWidth="1.5" />
              <circle cx="300" cy="320" r="125" fill="none" stroke="#fa9f22" strokeOpacity="0.45" strokeWidth="2" />
            </g>

            {/* orbital layer — dashed ring, accent dots and strands slowly revolve */}
            <g className="hero-orbit">
              <circle cx="300" cy="320" r="280" fill="none" stroke="#fa9f22" strokeOpacity="0.10" strokeWidth="1.5" strokeDasharray="2 6" />

              {/* connecting strands */}
              <path d="M160 240 Q230 290 250 305" fill="none" stroke="#fa9f22" strokeOpacity="0.18" strokeWidth="1.5" strokeDasharray="3 5" />
              <path d="M470 180 Q400 240 355 290" fill="none" stroke="#fa9f22" strokeOpacity="0.18" strokeWidth="1.5" strokeDasharray="3 5" />
              <path d="M500 430 Q420 390 365 360" fill="none" stroke="#fa9f22" strokeOpacity="0.15" strokeWidth="1.5" strokeDasharray="3 5" />

              {/* orbital accent dots — counter-rotate so they stay upright, plus twinkle */}
              <g className="hero-dots">
                <circle className="hero-dot" cx="160" cy="240" r="6" fill="#fa9f22" opacity="0.9" />
                <circle className="hero-dot hero-dot--2" cx="470" cy="180" r="4" fill="#fa9f22" opacity="0.6" />
                <circle className="hero-dot hero-dot--3" cx="500" cy="430" r="8" fill="#fa9f22" opacity="0.5" />
                <circle className="hero-dot hero-dot--4" cx="135" cy="450" r="5" fill="#fa9f22" opacity="0.7" />
                <circle className="hero-dot hero-dot--5" cx="420" cy="510" r="3" fill="#fa9f22" opacity="0.55" />
              </g>
            </g>

            {/* sonar pings — expanding rings radiating from the orb */}
            <g className="hero-pings">
              <circle className="hero-ping" cx="300" cy="320" r="80" fill="none" stroke="#fa9f22" strokeWidth="2" />
              <circle className="hero-ping hero-ping--2" cx="300" cy="320" r="80" fill="none" stroke="#fa9f22" strokeWidth="2" />
              <circle className="hero-ping hero-ping--3" cx="300" cy="320" r="80" fill="none" stroke="#fa9f22" strokeWidth="2" />
            </g>

            {/* center orb — soft pulse */}
            <g className="hero-orb">
              <circle cx="300" cy="320" r="80" fill="url(#loginHeroOrb)" />
              <circle cx="300" cy="320" r="80" fill="none" stroke="#ffffff" strokeOpacity="0.08" strokeWidth="2" />

              {/* headphone glyph inside orb */}
              <path d="M260 322 a40 40 0 0 1 80 0" fill="none" stroke="#ffffff" strokeWidth="6" strokeLinecap="round" />
              <rect x="252" y="320" width="18" height="32" rx="6" fill="#ffffff" />
              <rect x="330" y="320" width="18" height="32" rx="6" fill="#ffffff" />
            </g>
          </svg>

          <div className="hero-caption">
            <h2>Welcome to Noise Connect</h2>
            <p>Stay connected with every customer, every conversation.</p>
          </div>
        </div>
        <div className="logo">
          <img src="/img/nlogo.png" alt="" />
        </div>
        <ReactModal
          isOpen={this.state.openOtp}
          contentLabel="Minimal Modal Example"
          style={customStylesDO}
          ariaHideApp={false}
          className="loginOtp"
        >
          <div className='modalHeader'>
            <h2 id="rModal_head">PLEASE ENTER OTP TO LOGIN</h2>
            <button id="close_rModal" onClick={() => this.setState({ openOtp: false, inputOtp: '' })}><i className="fas fa-times"></i></button>
          </div>
          <p className="content">We have sent an OTP on your registered {this.state.otpType === 'email' ? 'email address' : 'mobile number'}</p>
          <input maxLength={6} type="text" id="InputLoginOtp" placeholder="Enter OTP" onChange={e => {
            let temp = e.target.value;
            this.setState({ inputOtp: temp })
          }} value={this.state.inputOtp} />
          <div className="otp-btn-wrapper">
            {
              seconds > 0 ? <span>Resend OTP in {seconds}s</span> : <button className='text-center rended-otp-button btn' onClick={this.resend}>
                Resend OTP
              </button>
            }
          </div>
          <button id="send_rModal" type="button" onClick={this.verifyOtp}>Verify OTP</button>
        </ReactModal>
      </div>
    )
  }
}

// LoginComponent.propTypes = {
//   createLogin: PropTypes.func.isRequired
// };

const mapStateToProps = state => ({
  loginRes: state.user.loginRes,
  userLogin: state.user.userLogin
})

export default connect(mapStateToProps, { loginOtp, verifyLoginOtp, createLogin })(LoginComponent);